import './Paypal.css'
function Paypal (){
  return(
    <div className="paypal-container">
      Paypal
    </div>
  )
}
export default Paypal